// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkSent_loginFormContainer__g4Oef {
  width: 448px;
  height: 455px;
  background-color: var(--color-bg-login-box);
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  box-shadow: 0px 3px 6px var(--color-theme-cloud);
  display: flex;
  flex-direction: column;
}

.LinkSent_loginFormHeader__F4GWU {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 40px;
}

.LinkSent_loginForm__Okjov {
  margin: 40px;
}

.LinkSent_info_icon__zrh0y {
  width: 70px !important;
  height: 80px !important;
  color: var(--color-theme-blue);
}

.LinkSent_link_sent_content__JTBGH {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

.LinkSent_go_to_login_button__hrqH1 {
  width: 270px;
  height: 41px;
  border: 1px solid var(--color-theme-blue) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-blue) !important;
  cursor: pointer;
  font-size: 16px;
}

.LinkSent_go_to_login_button__hrqH1:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.LinkSent_go_to_login_button_gray__cSVYX {
  width: 270px;
  height: 41px;
  border: 1px solid var(--color-theme-deactivated) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-deactivated) !important;
  cursor: pointer;
  font-size: 16px;
}

.LinkSent_go_to_login_button_gray__cSVYX:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-deactivated) !important;
}

.LinkSent_error_message__shMqb {
  color: var(--color-theme-red);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ForgotPassword/LinkSent/LinkSent.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,qDAAqD;EACrD,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2DAA2D;EAC3D,kBAAkB;EAClB,qDAAqD;EACrD,gDAAgD;EAChD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".loginFormContainer {\n  width: 448px;\n  height: 455px;\n  background-color: var(--color-bg-login-box);\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 80px;\n  box-shadow: 0px 3px 6px var(--color-theme-cloud);\n  display: flex;\n  flex-direction: column;\n}\n\n.loginFormHeader {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 40px;\n}\n\n.loginForm {\n  margin: 40px;\n}\n\n.info_icon {\n  width: 70px !important;\n  height: 80px !important;\n  color: var(--color-theme-blue);\n}\n\n.link_sent_content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n}\n\n.go_to_login_button {\n  width: 270px;\n  height: 41px;\n  border: 1px solid var(--color-theme-blue) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-blue) !important;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.go_to_login_button:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.go_to_login_button_gray {\n  width: 270px;\n  height: 41px;\n  border: 1px solid var(--color-theme-deactivated) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-deactivated) !important;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.go_to_login_button_gray:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-deactivated) !important;\n}\n\n.error_message {\n  color: var(--color-theme-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginFormContainer": `LinkSent_loginFormContainer__g4Oef`,
	"loginFormHeader": `LinkSent_loginFormHeader__F4GWU`,
	"loginForm": `LinkSent_loginForm__Okjov`,
	"info_icon": `LinkSent_info_icon__zrh0y`,
	"link_sent_content": `LinkSent_link_sent_content__JTBGH`,
	"go_to_login_button": `LinkSent_go_to_login_button__hrqH1`,
	"go_to_login_button_gray": `LinkSent_go_to_login_button_gray__cSVYX`,
	"error_message": `LinkSent_error_message__shMqb`
};
export default ___CSS_LOADER_EXPORT___;
